<div class="report-model-header">
    <div class="info">
        <h3>{{ title | translate}} </h3>
        <span *ngIf="isShowCount" class="totalTransaction">({{ count | number : '1.0-1'}}<ng-container *ngIf="countTitle"> {{countTitle | translate}}</ng-container>)</span>

    </div>
</div>